import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    pagination: {
      page: 0,
      pageSize: 50,
    },
    search: "",
    title: "",
    taskIds: [],
    teamIds: [],
    createdByIds: [],
    assignees: [],
    dueDate: "",
    priority: { value: "", label: "" },
    workOrder: { value: "", label: "" },
  },
};

const taskBoardFiltersSlice = createSlice({
  name: "taskBoardFilters",
  initialState,
  reducers: {
    setTaskBoardFilter: (state, action) => {
      const { filterName, data } = action.payload;
      if (filterName === "pagination") {
        state.value.pagination = { ...state.value.pagination, ...data };
      } else {
        state.value[filterName] = data;
      }
    },
    resetTaskBoardFilters: (state) => {
      state.value = { ...initialState.value };
    },
    resetTaskBoardPagination: (state) => {
      state.value.pagination = { page: 0, pageSize: 10 };
    },
  },
});

export const { setTaskBoardFilter, resetTaskBoardFilters, resetTaskBoardPagination } =
  taskBoardFiltersSlice.actions;

export default taskBoardFiltersSlice.reducer;
